<template>
   <div>
       <app-filters
        :types="types"
        @filter="onFilter"
        @clean="cleanFilter"
       />
        <b-alert variant="success" v-if="!list.length" show>¡No hay datos!</b-alert>
        <app-clients-mails-for-delivering-list v-if="list.length"
            :data="data"
            :on-change-page="onChangePageMailsForDelivering"
        />
   </div>
</template>
<script>
import ClientsMailsForDeliveringList from './ClientsMailsForDeliveringList/ClientsMailsForDeliveringList.vue';
import ClientsMailsForDeliveringFilters from './ClientsMailsForDeliveringFilters/ClientsMailsForDeliveringFIlters.vue';
export default {
    components: {
        appClientsMailsForDeliveringList: ClientsMailsForDeliveringList,
        appFilters: ClientsMailsForDeliveringFilters 
    },
    data(){
        return{
            list: []
        }
    },

    watch: {
        data(val){
            this.list = this.data.data;
        }
    },

    props: {
        data: {
            required: true
        },
        onChangePageMailsForDelivering: {
            type: Function
        },
        types: {
            type: Array,
            required: true
        },
        onFilter: {
            type: Function
        },
        cleanFilter: {
            type: Function
        }
    }
}
</script>

